export type OnboardingChangeHandler = (screen: string) => void;

export class DatabaseOnboardingService {
	private onOnboardingChangeCallback: OnboardingChangeHandler;

	constructor() {
		this.onOnboardingChangeCallback = () => {};
	}

	dispose() {
		this.onOnboardingChangeCallback = () => {};
	}

	/**
	 * This is called in Confluence to register the onOnboardingChange callback
	 * which will be called in Canvas via the Bridge API whenever a new onboarding
	 * screen is shown.
	 *
	 * @param callback A callback that is passed the new onboarding screen name
	 * whenever it changes
	 */
	registerOnOnboardingChangeCallback(callback: OnboardingChangeHandler) {
		this.onOnboardingChangeCallback = callback;
	}

	/**
	 * This is called in Canvas via the Bridge API whenever the onboarding screen
	 * changes
	 *
	 * @param {string} screen The new onboarding screen name
	 */
	onOnboardingChange(screen: string) {
		this.onOnboardingChangeCallback(screen);
	}
}
